import React, { useEffect, useCallback, useState } from "react";
import { Outlet, useNavigate, NavLink } from "react-router-dom";
import { Layout, Menu, Dropdown, Avatar } from "antd";
import {
  UserOutlined,
  DownOutlined,
  LogoutOutlined,
  FormOutlined,
  CloseOutlined,
  MenuUnfoldOutlined,
  FileDoneOutlined,
  SearchOutlined,
  UsergroupAddOutlined,
  ReconciliationOutlined,
} from "@ant-design/icons";
import "../Dashboard/Dashboard.css";
import senalogo from "../../assets/logo.png";
import { useAuth } from "../AuthContext";

const { Header, Sider, Content } = Layout;

const Dashboard = () => {
  const navigate = useNavigate();
  const [menuOption, setMenuOption] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const { authenticated, userName, checkAuth, logout, userRole } = useAuth();

  const toggleCollapsed = () => {
    setCollapsed((prev) => !prev);
  };

  const handleChangePassword = () => {
    navigate("/dashboard/ChangePassword");
  };

  const handleLogout = async () => {
    try {
      checkAuth();
      const response = await fetch("/api/portal/pms/logout", {
        method: "GET",
      });

      if (response.ok) {
        sessionStorage.clear();
        logout();
      } else {
        console.log("API Logout Error:", response.status, response.statusText);
      }
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  const menu = (
    <Menu>
      <Menu.Item onClick={handleChangePassword} icon={<FormOutlined />}>
        Change Password
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item onClick={handleLogout} icon={<LogoutOutlined />}>
        Logout
      </Menu.Item>
    </Menu>
  );

  const handleMenuChange = ({ key }) => {
    setMenuOption(key);
    sessionStorage.setItem("selectedMenu", key);
  };

  const capitalizeName = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const getInitials = (name) => {
    const nameParts = name.split(" ");
    if (nameParts.length > 1) {
      return (
        nameParts[0].charAt(0).toUpperCase() +
        nameParts[nameParts.length - 1].charAt(0).toUpperCase()
      );
    } else {
      return nameParts[0].charAt(0).toUpperCase();
    }
  };

  const stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).substr(-2);
    }
    return color;
  };

  if (!authenticated) {
    return null;
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider collapsible collapsed={collapsed} onCollapse={toggleCollapsed}>
        <div
          className="logopulse"
          style={{
            textAlign: "center",
            backgroundColor: "#01013f",
            padding: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "40px",
          }}
        >
          <img src={senalogo} style={{ width: 72, marginBottom: 20 }} />
          <span
            style={{
              color: "white",
              cursor: "pointer",
              position: "absolute",
              top: 10,
              right: 10,
            }}
            onClick={toggleCollapsed}
          >
            {collapsed ? (
              <CloseOutlined style={{ fontSize: "24px" }} />
            ) : (
              <MenuUnfoldOutlined style={{ fontSize: "24px" }} />
            )}
          </span>
        </div>

        <div>
          <Menu
            onClick={(key) => {
              handleMenuChange(key);
            }}
            theme="dark"
            mode="inline"
            defaultSelectedKeys={["users"]}
            selectedKeys={menuOption}
          >
            {!collapsed && (
              <p
                style={{
                  textAlign: "center",
                  color: "white",
                  marginTop: "-20px",
                }}
              >
                Welcome {capitalizeName(userName)}
              </p>
            )}

            {userRole === "AD" && (
              <>
                <Menu.Item
                  key="Admin"
                  style={{ textDecoration: "none!important" }}
                  icon={<UsergroupAddOutlined style={{ fontSize: 17 }} />}
                >
                  <NavLink to="/dashboard/Admin">Admin</NavLink>
                </Menu.Item>

                <Menu.Item
                  key="PetitionManagement"
                  style={{ textDecoration: "none!important" }}
                  icon={<FormOutlined style={{ fontSize: 17 }} />}
                >
                  <NavLink to="/dashboard/PetitionManagement">
                    Petition Management
                  </NavLink>
                </Menu.Item>

                {/* <Menu.Item
                  key="Source"
                  icon={<ReconciliationOutlined style={{ fontSize: 17 }} />}
                >
                  <NavLink to="/dashboard/Source">Source</NavLink>
                </Menu.Item>

                <Menu.Item
                  key="Categories"
                  icon={<FileDoneOutlined style={{ fontSize: 17 }} />}
                >
                  <NavLink to="/dashboard/Categories">Categories</NavLink>
                </Menu.Item> */}
                <Menu.Item
                  key="AssigneSearch"
                  style={{ textDecoration: "none!important" }}
                  icon={<SearchOutlined style={{ fontSize: 17 }} />}
                >
                  <NavLink to="/dashboard/AssigneSearch">
                    Petition Search
                  </NavLink>
                </Menu.Item>

                <Menu.Item
                  key="AddItem"
                  icon={<FileDoneOutlined style={{ fontSize: 17 }} />}
                >
                  <NavLink to="/dashboard/AddItem">AddItem</NavLink>
                </Menu.Item>

                {/* <Menu.Item
                  key="Assigne"
                  icon={<UserOutlined style={{ fontSize: 17 }} />}
                >
                  <NavLink to="/dashboard/Assigne">Assigne</NavLink>
                </Menu.Item> */}
              </>
            )}

            {(userRole === "PAT" || userRole === "PAS") && (
              <Menu.Item
                key="PetitionManagement"
                style={{ textDecoration: "none!important" }}
                icon={<FormOutlined style={{ fontSize: 17 }} />}
              >
                <NavLink to="/dashboard/PetitionManagement">
                  Petition Management
                </NavLink>
              </Menu.Item>
            )}

            {userRole === "PCS" && (
              <Menu.Item
                key="AssigneSearch"
                style={{ textDecoration: "none!important" }}
                icon={<SearchOutlined style={{ fontSize: 17 }} />}
              >
                <NavLink to="/dashboard/AssigneSearch">AssigneSearch</NavLink>
              </Menu.Item>
            )}
          </Menu>
        </div>
      </Sider>
      <Layout>
        <Header
          className="header"
          style={{
            height: "60px",
            width: "100%",
            position: "fixed",
            top: 0,
            zIndex: 1000,
            boxShadow: "0 3px 5px #607D8B",
            backgroundColor: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 24px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexGrow: 1,
              justifyContent: "center",
            }}
          >
            <img
              src={senalogo}
              alt="Logo"
              style={{ width: 50, marginRight: 16 }}
            />
            <span
              style={{ color: "#d92027", fontSize: "30px", fontWeight: 600 }}
            >
              Janasena{" "}
            </span>
          </div>
          <div style={{ marginRight: collapsed ? "80px" : "230px" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <a
                className="ant-dropdown-link logoutdropdown"
                onClick={(e) => e.preventDefault()}
                style={{
                  color: stringToColor(userName),
                }}
              >
                <Avatar
                  style={{
                    backgroundColor: stringToColor(userName),
                    marginRight: 8,
                  }}
                >
                  {getInitials(userName)}
                </Avatar>

                <DownOutlined />
              </a>
            </Dropdown>
          </div>
        </Header>
        <Content
          style={{
            padding: "0 24px",
            marginTop: 64,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
